// extracted by mini-css-extract-plugin
export default {"container":"Successful_container__j-G1F"};